import React from 'react';
import { Container as BootstrapContainer } from 'react-bootstrap';

const Container = ({ 
    children, 
    fluid = false, 
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    style, 
    className,
    ...props 
}) => {
    return (
        <BootstrapContainer className={className + ' main-container'} style={style} {...props}>
            {children}
        </BootstrapContainer>
    );
};

export default Container;

